/** Seed keywords for smart search autocomplete (equipment + offer types).
 * Dynamically enriched at runtime by /search/suggestions from published listings.
 */
export const SEARCH_EQUIPMENT_KEYWORDS = [
  "Mini-pelle",
  "Pelle",
  "Pelleteuse",
  "Chargeuse",
  "Chargeuse compacte",
  "Télescopique",
  "Chariot télescopique",
  "Nacelle",
  "Compacteur",
  "Bulldozer",
  "Tracteur",
  "Tracteur tondeuse",
  "Motoculteur",
  "Tondeuse",
  "Débroussailleuse",
  "Tronçonneuse",
  "Taille-haies",
  "Broyeur",
  "Souffleur",
  "Robot de tonte",
  "Marteau-piqueur",
  "Meuleuse",
  "Perceuse",
  "Perforateur",
  "Visseuse",
  "Scie circulaire",
  "Compresseur",
  "Groupe électrogène",
  "Générateur",
  "Bétonnière",
  "Échafaudage",
  "Remorque",
  "Remorque agricole",
  "Chariot élévateur",
  "Transpalette",
  "Nettoyeur haute pression",
  "Poste à souder",
  "Faucheuse",
  "Presse",
  "Semoir",
  "Pulvérisateur",
  "Dessoucheuse",
  "Microtracteur",
];

export const SEARCH_BRAND_KEYWORDS = [
  "Kubota",
  "Bobcat",
  "Caterpillar",
  "Cat",
  "Volvo",
  "JCB",
  "Hitachi",
  "Komatsu",
  "Takeuchi",
  "Husqvarna",
  "Stihl",
  "John Deere",
  "Case",
  "New Holland",
  "Manitou",
  "Merlo",
  "Genie",
  "Haulotte",
  "Wacker Neuson",
  "Yanmar",
];

export const SEARCH_OFFER_TYPES = [
  { label: "Vente", value: "vente" },
  { label: "Location", value: "location" },
  { label: "Réparation", value: "réparation" },
  { label: "Pièces détachées", value: "pièces détachées" },
];

/** Fold accents + lowercase for accent/case-insensitive matching (client-side). */
export function foldText(s) {
  return String(s || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}
